export default "__VITE_PUBLIC_ASSET__bd95880b__"